export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4791.4301b5a3.jpg";